"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.EventBus = new vue_1.default();
exports.events = {
    common: {
        search: {
            phrase: "common.search.phrase",
            hit: "common.search.hit"
        },
        fullScreenWindow: "common.fullscreenWindow"
    },
    district: {
        all: "district.all",
        create: "district.create",
        rename: "district.rename",
        delete: "district.delete",
        change: "district.change",
        select: "district.select",
        last_modified: {
            update: "district.last_modified.update",
            accept: "district.last_modified.accept"
        }
    },
    unit: {
        all: "unit.all",
        create: "unit.create",
        rename: "unit.rename",
        district: {
            update: "unit.district.update"
        },
        change: "unit.change",
        select: "unit.select",
        delete: "unit.delete"
    },
    role: {
        select: "role.select",
        delete: "role.delete",
        create: "role.create",
        rename: "role.rename",
        permission: {
            update: "role.permission.update"
        }
    },
    user: {
        all: "user.all",
        create: "user.create",
        update: "user.update",
        delete: "user.delete"
    },
    scout: {
        all: "scout.all",
        create: "scout.create",
        update: "scout.update",
        unit: {
            update: "scout.unit.update"
        },
        archive: "scout.archive",
        archived: "scout.archived",
        displayState: "scout.displayState"
    },
    contribution: {
        update: "contribution.update"
    }
};
